import { TypedDocumentNode, gql } from '@apollo/client';

import { type FragmentOf, unmaskFragment } from 'lib/graphql';

import {
  DumbPlayerAppearance,
  Props as DumbPlayerAppearanceProps,
} from '../DumbPlayerAppearance';
import type { PlayerAppearance_anyPlayer } from './__generated__/index.graphql';

type Props = {
  player: FragmentOf<PlayerAppearance_anyPlayer>;
} & Omit<DumbPlayerAppearanceProps, 'appearances'>;

export const PlayerAppearance = ({
  player: player_,
  mode,
  ...props
}: Props) => {
  const player = unmaskFragment(player_);

  const appearances: number = {
    LAST_FORTY_SO5_AVERAGE_SCORE: (player.lastFortySo5Appearances || 0) / 40,
    LAST_TEN_PLAYED_SO5_AVERAGE_SCORE: (player.lastTenSo5Appearances || 0) / 10,
    LAST_FIVE_SO5_AVERAGE_SCORE: (player.lastFiveSo5Appearances || 0) / 5,
    LAST_FIFTEEN_SO5_AVERAGE_SCORE:
      (player.lastFifteenSo5Appearances || 0) / 15,
  }[mode];

  return (
    <DumbPlayerAppearance {...props} mode={mode} appearances={appearances} />
  );
};

PlayerAppearance.fragments = {
  anyPlayer: gql`
    fragment PlayerAppearance_anyPlayer on AnyPlayerInterface {
      slug
      lastFiveSo5Appearances
      lastTenSo5Appearances
      lastFifteenSo5Appearances
      lastFortySo5Appearances
    }
  ` as TypedDocumentNode<PlayerAppearance_anyPlayer>,
};
